import { Component, Input } from '@angular/core';
import { AvailableDataColumn } from '../../models/grid';
@Component({
    selector: 'cdp-grid-header-cell',
    templateUrl: 'grid-header-cell.component.html',
    standalone: false
})
export class GridHeaderCellComponent<T> {
    @Input() column: AvailableDataColumn<T>;
}
